import React from 'react';

const StaticGalleryResponsive = () => {
  // Generate array of image numbers for extensions (1-13)
  const extensionImages = Array.from({ length: 13 }, (_, i) => i + 1);
  
  // Generate array of image numbers for blonding (1-13)
  const blondingImages = Array.from({ length: 13 }, (_, i) => i + 1);

  const renderGalleryItem = (num, index, type) => {
    const imagePath = type === 'extensions' 
      ? `/images/Gallery/gallery-htdf-extensions-${num}.webp`
      : `/images/Gallery/gallery-htdf-blonding-${num}.webp`;
    
    const altText = type === 'extensions' 
      ? `Flat Tip Extension ${num}`
      : `Luxury Blonding ${num}`;
    
    // Determine grid column span based on position
    let responsiveClasses = '';
    
    if (index === 0) {
      // First image - 70% width (same height as second image)
      responsiveClasses = 'col-span-12 md:col-span-8 lg:col-span-8 aspect-[7/4.6]';
    } else if (index === 1) {
      // Second image - 30% width (same height as first image)
      responsiveClasses = 'col-span-12 md:col-span-4 lg:col-span-4 aspect-[3/4]';
    } else if (index === 11) {
      // Second to last image - 30% width (same height as last image)
      responsiveClasses = 'col-span-12 md:col-span-4 lg:col-span-4 aspect-[3/4]';
    } else if (index === 12) {
      // Last image - 70% width (same height as second to last)
      responsiveClasses = 'col-span-12 md:col-span-8 lg:col-span-8 aspect-[7/4.6]';
    } else {
      // Middle rows - 3 images per row (each takes 4 columns)
      responsiveClasses = 'col-span-12 sm:col-span-6 md:col-span-4 aspect-square';
    }
    
    return (
      <div key={num} className={`${responsiveClasses} overflow-hidden group cursor-pointer`}>
        <img 
          src={imagePath}
          alt={altText}
          className="w-full h-full object-cover transition-all duration-500 group-hover:scale-110"
          loading="lazy"
        />
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
        
        {/* Beautiful Clients Section */}
        <section className="mb-12 sm:mb-16 lg:mb-20">
          <h2 className="text-center text-[40px] sm:text-[48px] md:text-[56px] lg:text-[64px] font-ligrht tacking-[0.05em] mb-8 sm:mb-10 lg:mb-12 text-gray-800 uppercase" style={{ fontFamily: 'Montserrat, sans-serif',fontWeight: '700' }}>
            OUR BEAUTIFUL CLIENTS
          </h2>
          <div className="w-full flex justify-center">
            <div className="w-full max-w-7xl overflow-hidden shadow-sm">
              <img 
                src="/images/Gallery/b_clients.webp" 
                alt="Beautiful Clients" 
                className="w-full h-auto object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
          </div>
        </section>

        {/* Flat Tip Extensions Section */}
        <section className="mb-12 sm:mb-16 lg:mb-20">
          <h2 className="text-center text-[20px] sm:text-[22px] md:text-[24px] font-light tracking-[0.1em] mb-6 sm:mb-8 lg:mb-10 text-gray-800 uppercase" style={{ fontFamily: 'Montserrat, sans-serif' ,fontWeight: '600'}}>
            FLAT TIP EXTENSIONS
          </h2>
          <div className="grid grid-cols-12 gap-2 sm:gap-3 md:gap-4">
            {extensionImages.map((num, index) => renderGalleryItem(num, index, 'extensions'))}
          </div>
        </section>

        {/* Luxury Blonding Section */}
        <section className="mb-12 sm:mb-16 lg:mb-20">
          <h2 className="text-center text-[20px] sm:text-[22px] md:text-[24px] font-light tracking-[0.1em] mb-6 sm:mb-8 lg:mb-10 text-gray-800 uppercase px-4" style={{ fontFamily: 'Montserrat, sans-serif',fontWeight: '600' }}>
            LUXURY BLONDING & SOFT PINK BALAYAGE
          </h2>
          <div className="grid grid-cols-12 gap-2 sm:gap-3 md:gap-4">
            {blondingImages.map((num, index) => renderGalleryItem(num, index, 'blonding'))}
          </div>
        </section>

        {/* Social Media Section */}
        <section className="mt-16 sm:mt-20 lg:mt-24 pt-8 sm:pt-10 lg:pt-12 border-t border-gray-200">
          {/* Latest Work Text */}
          <div className="text-center mb-8">
            <p className="text-[18px] sm:text-[20px] md:text-[22px] font-light tracking-[0.15em] text-gray-800 uppercase" style={{ fontFamily: 'Montserrat, sans-serif',fontWeight: '700',fontSize:'16px',color:"#C7A064"  }}>
              CHECK OUT OUR LATEST WORK
            </p>
          </div>
          
          {/* Social Icons */}
          <div className="flex justify-center items-center gap-6 sm:gap-8 lg:gap-10">
            <a 
              href="https://www.facebook.com/h2d4easto" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="group transition-all duration-300 hover:-translate-y-2"
              aria-label="Visit our Facebook page"
            >
              <img 
                src="/images/Gallery/facebook.png" 
                alt="Facebook" 
                className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 object-contain group-hover:scale-110 transition-transform duration-300"
              />
            </a>
            <a 
              href="https://www.instagram.com/h2d4easton/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="group transition-all duration-300 hover:-translate-y-2"
              aria-label="Visit our Instagram page"
            >
              <img 
                src="/images/Gallery/Insta_Icon.png" 
                alt="Instagram" 
                className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 object-contain group-hover:scale-110 transition-transform duration-300"
              />
            </a>
            <a 
              href="https://www.tiktok.com/@h2d4easton" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="group transition-all duration-300 hover:-translate-y-2"
              aria-label="Visit our TikTok page"
            >
              <img 
                src="/images/Gallery/tiktok-icon.png" 
                alt="TikTok" 
                className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 object-contain group-hover:scale-110 transition-transform duration-300"
              />
            </a>
          </div>
        </section>
      </div>
    </div>
  );
};

export default StaticGalleryResponsive;